export default "__VITE_ASSET__B8oPDn$G__"